import styled from 'styled-components';
import {
  Checkbox as PjCheckbox,
  NumberInput as NumberInputComponent,
  Radio as PjRadio,
} from '@prisjakt/ui-inputs';
import Button from '@prisjakt/ui-button';

import { media, colors, layout } from '@prisjakt/ui-base';

export const Checkbox = styled(PjCheckbox)`
  margin-bottom: ${layout.spacing.xSmall};
`;

export const PriceStepCheckbox = styled(PjCheckbox)`
  margin-left: ${layout.spacing.medium};
`;

export const CancelButton = styled.div`
  color: ${p => p.theme.text.primary};
  text-decoration: underline;
  text-transform: none;
  font-weight: normal;
  margin-top: 2rem;
`;

export const SaveAlertButton = styled(Button)`
  margin: 10px 0;
  width: 100%;
`;

interface EmailInputProps {
  error?: boolean;
}

export const EmailInput = styled.div<EmailInputProps>`
  .pj-ui-text-input {
    margin-right: 1rem;
    &--input {
      height: 45px;
    }
  }
  ${media.smallOnly`
    .pj-ui-text-input {
      margin-right: 0;
    }
  `}
  ${p =>
    p.error &&
    `
    .pj-ui-input--input {
      border-color: ${colors.red2};
    }
  `}
`;

interface EmailHintProps extends EmailInputProps {
  visible?: boolean;
  discreetLink?: boolean;
}

export const RatingWrapper = styled.div`
  display: flex;
  align-items: center;
  > p {
    margin-bottom: 0;
  }

  > div {
    margin-right: 1rem;
  }
`;

export const EmailHint = styled.div.attrs({ 'data-test': 'EmailHint' })<
  EmailHintProps
>`
  && {
    margin: 0.5rem 0;

    display: ${p => (p.visible ? `block` : 'none')};

    a {
      text-decoration: underline !important;
      ${p => p.discreetLink && `color: ${colors.darkGray2};`}
    }

    ${p => p.error && `color: ${colors.red2};`}

    p {
      margin: 0;
    }
  }
`;

export const AlertForm = styled.form`
  ${media.smallOnly`
  .pj-ui-input {
  margin-bottom: 1rem;
  }
  `}
`;

export const PriceBelowWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
`;

export const NumberInput = styled(NumberInputComponent)`
  input {
    width: 80px;
  }
`;

export const PriceStepWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: ${layout.spacing.xSmall};
  flex-wrap: wrap;
`;

export const PriceInputWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  margin-top: ${layout.spacing.xSmall};
`;

export const MarketCurrency = styled.span`
  margin-left: ${layout.spacing.xSmall};
`;

export const Header = styled.p`
  font-weight: 600;
  color: ${colors.darkBlue2};
`;

export const Radio = styled(PjRadio)`
  margin-right: ${layout.spacing.xSmall};
`;

type ShopsFilterWrapperProps = {
  isAuthenticated?: boolean;
};

export const ShopsFilterWrapper = styled.div<ShopsFilterWrapperProps>`
  border-top: solid 1px ${colors.lightGray1};
  margin-top: ${layout.spacing.small};
  padding-top: ${layout.spacing.small};
  margin-bottom: ${layout.spacing.small};
  opacity: ${props => (props.isAuthenticated ? '1' : '0.5')};
`;
